/* KD Modern — small progressive-enhancement helpers */
(function () {
  'use strict';

  // Sticky header scrolled state
  const header = document.querySelector('.kd-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile drawer
  document.querySelectorAll('[data-kd-drawer-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.querySelector(btn.getAttribute('data-kd-drawer-open'));
      if (target) { target.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-kd-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const drawer = btn.closest('.kd-drawer');
      if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });
  document.querySelectorAll('.kd-drawer').forEach((drawer) => {
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });

  // Tabs
  document.querySelectorAll('[data-kd-tabs]').forEach((root) => {
    const btns = root.querySelectorAll('.kd-tabs__btn');
    const panels = root.querySelectorAll('.kd-tabs__panel');
    btns.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        btns.forEach((b) => b.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
  });

  // Product gallery thumb swap
  document.querySelectorAll('[data-kd-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-kd-gallery-main] img');
    gallery.querySelectorAll('[data-kd-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-kd-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.getAttribute('data-src');
        if (main && src) main.src = src;
      });
    });
  });

  // Qty stepper
  document.querySelectorAll('[data-kd-qty]').forEach((root) => {
    const input = root.querySelector('input[type="number"]');
    if (!input) return;
    root.querySelector('[data-kd-qty-dec]')?.addEventListener('click', () => {
      input.value = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    root.querySelector('[data-kd-qty-inc]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Testimonials rotator
  document.querySelectorAll('[data-kd-quotes]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('.kd-quotes__slide'));
    const dots = Array.from(root.querySelectorAll('.kd-quotes__dot'));
    if (slides.length < 2) return;
    let i = 0;
    const show = (n) => {
      slides.forEach((s, idx) => s.style.display = idx === n ? 'block' : 'none');
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === n));
      i = n;
    };
    dots.forEach((d, idx) => d.addEventListener('click', () => show(idx)));
    show(0);
    setInterval(() => show((i + 1) % slides.length), 6000);
  });

  // Inline predictive search (header desktop bar)
  (function () {
    var wrap = document.getElementById('kd-inline-search');
    var input = document.getElementById('kd-inline-q');
    var dropdown = document.getElementById('kd-inline-dropdown');
    if (!wrap || !input || !dropdown) return;

    var ctrl, debounce;

    var money = function (cents) { return '$' + (parseFloat(cents) / 100).toFixed(2); };

    var close = function () {
      dropdown.classList.remove('is-open');
      dropdown.innerHTML = '';
    };

    var renderInline = function (data, q) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];
      var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
      var html = '';

      if (queries.length) {
        html += '<div class="kd-isd__group"><p class="kd-eyebrow">Suggestions</p><ul class="kd-isd__queries">';
        queries.slice(0, 4).forEach(function (sq) {
          html += '<li><a href="/search?q=' + encodeURIComponent(sq.query_highlighted || sq.text) + '&options[prefix]=last">' +
            (sq.query_highlighted || sq.text) + '</a></li>';
        });
        html += '</ul></div>';
      }

      if (products.length) {
        html += '<div class="kd-isd__group"><p class="kd-eyebrow">Products</p><ul class="kd-isd__products">';
        products.slice(0, 4).forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + '&width=120' : '';
          html += '<li><a class="kd-isd__product" href="' + p.url + '">' +
            '<div class="kd-isd__product-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<span class="kd-isd__product-title">' + p.title + '</span>' +
            '<span class="kd-isd__product-price">' + money(p.price) + '</span>' +
            '</a></li>';
        });
        html += '</ul></div>';
      }

      if (collections.length) {
        html += '<div class="kd-isd__group"><p class="kd-eyebrow">Collections</p><ul class="kd-isd__queries">';
        collections.slice(0, 3).forEach(function (c) {
          html += '<li><a href="' + c.url + '">' + c.title + '</a></li>';
        });
        html += '</ul></div>';
      }

      html += '<div class="kd-isd__footer"><a href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last">View all results for <strong>' + q.replace(/</g, '&lt;') + '</strong> →</a></div>';

      dropdown.innerHTML = html;
      dropdown.classList.add('is-open');
    };

    var search = function (q) {
      if (!q || q.length < 2) { close(); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=5&resources[options][unavailable_products]=last',
        { signal: ctrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderInline(data, q); })
        .catch(function () {});
    };

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { search(input.value.trim()); }, 160);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length > 1) search(input.value.trim());
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

  // Predictive search overlay
  (function () {
    const modal = document.getElementById('kd-search');
    if (!modal) return;
    const input = modal.querySelector('[data-kd-search-input]');
    const results = modal.querySelector('[data-kd-search-results]');
    const emptyHTML = results ? results.innerHTML : '';
    let ctrl;

    const open = () => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input && input.focus(), 50);
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-kd-search-open]').forEach((b) =>
      b.addEventListener('click', (e) => { e.preventDefault(); open(); })
    );
    modal.querySelectorAll('[data-kd-search-close]').forEach((b) =>
      b.addEventListener('click', close)
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
        e.preventDefault(); open();
      }
    });

    const money = (cents) => {
      const n = (parseFloat(cents) / 100).toFixed(2);
      return '$' + n;
    };

    const render = (data, q) => {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
      const pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
      const articles = (data.resources && data.resources.results && data.resources.results.articles) || [];

      if (!products.length && !collections.length && !pages.length && !articles.length) {
        results.innerHTML = '<div class="kd-search__noresults"><p>No results for <strong>' + q.replace(/</g,'&lt;') + '</strong></p><p class="kd-text-muted">Try a different keyword or browse the shop.</p></div>';
        return;
      }

      let html = '';
      if (products.length) {
        html += '<div class="kd-search__group"><p class="kd-eyebrow">Products</p><div class="kd-search__products">';
        products.slice(0, 6).forEach((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          html += '<a class="kd-search__product" href="' + p.url + '">' +
            '<div class="kd-search__product-media">' + (img ? '<img src="' + img + '&width=200" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="kd-search__product-body"><span class="kd-search__product-title">' + p.title + '</span>' +
            '<span class="kd-search__product-price">' + money(p.price) + '</span></div>' +
            '</a>';
        });
        html += '</div></div>';
      }
      if (collections.length) {
        html += '<div class="kd-search__group"><p class="kd-eyebrow">Collections</p><ul class="kd-search__list">';
        collections.slice(0, 4).forEach((c) => {
          html += '<li><a href="' + c.url + '">' + c.title + '</a></li>';
        });
        html += '</ul></div>';
      }
      if (articles.length || pages.length) {
        html += '<div class="kd-search__group"><p class="kd-eyebrow">Pages</p><ul class="kd-search__list">';
        articles.slice(0, 3).forEach((a) => { html += '<li><a href="' + a.url + '">' + a.title + '</a></li>'; });
        pages.slice(0, 3).forEach((p) => { html += '<li><a href="' + p.url + '">' + p.title + '</a></li>'; });
        html += '</ul></div>';
      }
      html += '<div class="kd-search__viewall"><a class="kd-btn kd-btn--ghost" href="/search?q=' + encodeURIComponent(q) + '">View all results</a></div>';
      results.innerHTML = html;
    };

    let debounce;
    const search = (q) => {
      if (!q || q.length < 2) { results.innerHTML = emptyHTML; bindTags(); return; }
      results.innerHTML = '<div class="kd-search__loading">Searching…</div>';
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page' +
        '&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl.signal })
        .then((r) => r.json())
        .then((data) => render(data, q))
        .catch(() => {});
    };

    input && input.addEventListener('input', (e) => {
      clearTimeout(debounce);
      debounce = setTimeout(() => search(e.target.value.trim()), 180);
    });

    const bindTags = () => {
      modal.querySelectorAll('[data-kd-search-term]').forEach((b) => {
        b.addEventListener('click', () => {
          input.value = b.getAttribute('data-kd-search-term');
          input.focus();
          search(input.value);
        });
      });
    };
    bindTags();
  })();

  // Sticky ATC bar
  (function () {
    var bar = document.getElementById('kd-sticky-atc');
    var mainBtn = document.getElementById('kd-atc');
    if (!bar || !mainBtn) return;

    // Show/hide based on main button visibility
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0.5 });
    observer.observe(mainBtn);

    // Sync sticky selects → main form radios
    bar.querySelectorAll('[data-kd-sticky-opt]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var idx = parseInt(sel.getAttribute('data-kd-sticky-opt'), 10);
        var val = sel.value;
        // click the matching radio in the main form
        var radios = document.querySelectorAll('#kd-product-form input[type="radio"]');
        radios.forEach(function (r) {
          if (r.value === val) {
            // find if this radio belongs to this option index
            var label = r.closest('[data-kd-opt-idx]');
            if (label && parseInt(label.getAttribute('data-kd-opt-idx'), 10) === idx) {
              r.click();
            }
          }
        });
      });
    });

    // Keep sticky price/image in sync with main form updates
    var priceEl = document.getElementById('kd-price');
    var imgEl = document.getElementById('kd-main-img');
    var stickyPrice = document.getElementById('kd-sticky-price');
    var stickyImg = document.getElementById('kd-sticky-img');

    if (priceEl && stickyPrice) {
      new MutationObserver(function () {
        stickyPrice.textContent = priceEl.textContent.trim();
      }).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    if (imgEl && stickyImg) {
      new MutationObserver(function () {
        stickyImg.src = imgEl.src;
      }).observe(imgEl, { attributes: true, attributeFilter: ['src'] });
    }

    // Sticky ATC button submits the main form via the real submit button
    // so that <product-form>'s submit listener intercepts and ajax-adds to cart.
    document.getElementById('kd-sticky-atc-btn').addEventListener('click', function () {
      var mainBtn = document.getElementById('kd-atc');
      if (mainBtn) { mainBtn.click(); return; }
      var form = document.getElementById('kd-product-form');
      if (form && form.requestSubmit) form.requestSubmit();
    });

    // Keep sticky selects in sync when main radios change
    document.querySelectorAll('#kd-product-form input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var label = r.closest('[data-kd-opt-idx]');
        if (!label) return;
        var idx = label.getAttribute('data-kd-opt-idx');
        var sel = bar.querySelector('[data-kd-sticky-opt="' + idx + '"]');
        if (sel) sel.value = r.value;
      });
    });
  })();

  // Collection filters toggle (mobile)
  document.querySelectorAll('[data-kd-filters-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelector('.kd-collection__filters')?.classList.toggle('is-open');
    });
  });
})();
